import React from 'react';

export const Ecosystem = () => {
  return (
    <section className="mrm1-ecosystem-section">
      <div className="mrm2-mission-content-wrapper">
        <div className="mrm2-mission-text">
          <h2 className="mrm2-mission-title">
            <span className="mrm2-mission-title-span">DUAL-LINK</span>{' '}
            <span className="mrm2-mission-title-span">CONTROL</span>{' '}
          </h2>
          <p className="mrm2-mission-description">
            The <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> is
            available with two distinct control links. For standard operations,
            a <span style={{ whiteSpace: 'nowrap' }}>2.4GHz</span> Ghost
            protocol variant provides reliable control. For high-stakes
            missions, the EW-resilient IRONghost variant delivers a secure,
            long-range, jam-resistant connection on licensed sub-GHz bands.
          </p>
        </div>
      </div>
    </section>
  );
};
